import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Input,
  Item,
  Modal,
} from "semantic-ui-react";
import MaterialApi from "../../api/material";
import { MaterialUpdate } from "../../types/materialUpdate";
import Logo from "../../components/Logo/Logo";

import {
  useAppSelector as useSelector,
  useAppDispatch as useDispatch,
} from "../../hooks/redux";
import { setLastMaterialUpdated } from "../../redux/actions/lastMaterialUpdated";

import style from "./style.module.css";
import { validAliquota } from "../../utils/validAliquota";
import { isValidLeadTimeDays } from "../../utils/validLeadTimeDays";
import { calculateNetPrice } from "../../utils/calculateNetPrice";

export default function MaterialFormPage() {
  const dispatch = useDispatch();
  const params = useLocation();
  const isSimples = params.state === "Simples";

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [autoCompleteModal, setAutoCompleteModal] = useState(false);

  const state = useSelector((s) => s);
  const history = useHistory();
  const util = state.material.material?.util ?? "";
  const [origin, setOrigin] = useState("");
  const [ncm, setNcm] = useState("");
  const [price, setPrice] = useState("");
  const [aliIcms, setAliIcms] = useState("");
  const [reducaoIcms, setReducaoIcms] = useState("");
  const [icmsST, setIcmsST] = useState(false);
  const [aliIcmsST, setAliIcmsST] = useState("");
  const [aliIpi, setAliIpi] = useState("");
  const [leadTimeDays, setLeadTimeDays] = useState("");
  const [netPrice, setNetPrice] = useState("0");

  const validForm = () => {
    if (
      (origin === "" && !isSimples) ||
      ncm === "" ||
      ncm.length !== 8 ||
      price === "" ||
      (aliIcms === "" && !isSimples) ||
      (reducaoIcms === "" && !isSimples) ||
      (aliIpi === "" && !isSimples) ||
      !isValidLeadTimeDays(leadTimeDays) ||
      !(parseFloat(netPrice) > 0)
    ) {
      return false;
    }
    if (icmsST && aliIcmsST === "") {
      return false;
    }
    return true;
  };

  const saveMaterial = async () => {
    setLoading(true);
    setError("");
    try {
      if (isSimples) {
        await MaterialApi.updateMaterial(
          "",
          ncm,
          price,
          "0",
          "",
          false,
          "0",
          "0",
          parseInt(leadTimeDays, 10),
          price,
          state.material.material!.id
        );
      } else {
        await MaterialApi.updateMaterial(
          origin,
          ncm,
          price,
          aliIcms,
          reducaoIcms,
          icmsST,
          aliIcmsST,
          aliIpi,
          parseInt(leadTimeDays, 10),
          netPrice,
          state.material.material!.id
        );
      }
      dispatch(
        setLastMaterialUpdated({
          id: 0,

          createdAt: new Date(),

          origin: origin,

          ncm: ncm,

          price: price,

          icms: aliIcms,

          icmsReduction: reducaoIcms,

          IsIcmsSt: icmsST,

          icmsSt: aliIcmsST,

          ipi: aliIpi,

          leadTimeDays: parseInt(leadTimeDays, 10),

          netPrice: netPrice,
        })
      );
      history.replace("/materialContract");
    } catch (err) {
      console.log(err);
    }
    setError("Problema para salvar material");
    setLoading(false);
  };
  const loadMaterialState = (material: MaterialUpdate) => {
    setOrigin(material.origin ?? "");
    setNcm(material.ncm ?? "");
    setAliIcms(material.icms ?? "");
    setReducaoIcms(material.icmsReduction ?? "");
    setIcmsST(material.IsIcmsSt);
    setAliIcmsST(material.icmsSt ?? "");
    setAliIpi(material.ipi ?? "");
    setLeadTimeDays(material.leadTimeDays?.toString() ?? "");
  };

  const loadLastMaterial = () => {
    const updateMaterial = state.lastMaterialUpdated.material;
    if (updateMaterial) {
      loadMaterialState(updateMaterial);
    }
  };

  const loadMaterial = async () => {
    try {
      const updateMaterial = await MaterialApi.getUpdatedMaterial(
        state.material.material!.id
      );
      if (updateMaterial) {
        loadMaterialState(updateMaterial);
        setPrice(updateMaterial.price ?? "");
      } else {
        if (state.lastMaterialUpdated.material) {
          setAutoCompleteModal(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadMaterial();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isSimples) {
      setNetPrice(price !== "" ? price : "0");
    } else {
      const net = calculateNetPrice(price, aliIcms, aliIpi, util, reducaoIcms);
      setNetPrice(net > 0 ? net.toFixed(2) : "0");
    }
  }, [isSimples, price, aliIcms, aliIpi, util, reducaoIcms]);

  const validateCurrency = (s: string) => {
    if (s.length === 0) {
      return true;
    }

    if (s.includes(".") && s.split(".").length - 1 > 1) {
      return false;
    }

    if (s.split(".")[1] && s.split(".")[1].length > 2) {
      return false;
    }

    if (s.replaceAll(".", "").match(/\D/g) === null) {
      return true;
    }

    return false;
  };

  const validNcm = (s: string) => {
    if (s.match(/\D/g) === null && s.length <= 8) {
      return true;
    }
    return false;
  };
  return (
    <div className={style.container}>
      <Modal onOpen={() => setAutoCompleteModal(true)} open={autoCompleteModal}>
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Carregar as informações do ultimo material preenchido?
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Não"
            // labelPosition="right"
            onClick={async () => {
              setAutoCompleteModal(false);
            }}
            negative
          />
          <Button
            loading={loading}
            content="Sim"
            // labelPosition="right"
            icon="checkmark"
            onClick={async () => {
              await loadLastMaterial();
              setAutoCompleteModal(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Logo />
      {/* <Header as="h1">Smart Contract</Header> */}
      <Grid columns={isSimples ? 4 : 5} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Material/Serviço</Item.Header>
                <Item.Meta>
                  <label>Codigo:</label>
                  <span>{state.material.material?.material}</span>
                  <br />
                  <label>Preço Líquido:</label>
                  <span>{state.material.material?.price}</span>
                  <br />
                  <label>Descrição:</label>
                  <span>{state.material.material?.description}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>
        {isSimples ? null : (
          <Grid.Column>
            <Grid.Row textAlign="left">
              <label>Origem *: </label>
              <br />
              <br />
              <Dropdown
                placeholder="Origem"
                search
                selection
                value={origin}
                onChange={(_, { value }) => setOrigin(value!.toString())}
                options={[
                  { key: "Nacional", text: "Nacional", value: "Nacional" },
                  { key: "Importado", text: "Importado", value: "Importado" },
                ]}
              />
            </Grid.Row>
            <br />
            <Grid.Row textAlign="left">
              <label>Alíquota ICMS (%) *:</label>
              <br />
              <br />
              <Input
                value={aliIcms}
                onChange={(e) => {
                  if (validAliquota(e.target.value.replace(",", "."))) {
                    setAliIcms(e.target.value.replace(",", "."));
                  }
                }}
                onBlur={() => {
                  if (isNaN(parseFloat(aliIcms))) {
                    setAliIcms("");
                  } else {
                    setAliIcms(parseFloat(aliIcms).toFixed(2));
                  }
                }}
                placeholder="Alícota ICMS"
              />
            </Grid.Row>
            <br />
            <Grid.Row textAlign="left">
              <label>Alíquota ICMS ST *?: </label>
              <br />
              <br />
              <Input
                disabled={!icmsST}
                onChange={(e) => {
                  if (validAliquota(e.target.value.replace(",", "."))) {
                    setAliIcmsST(e.target.value.replace(",", "."));
                  }
                }}
                value={aliIcmsST}
                onBlur={() => {
                  if (isNaN(parseFloat(aliIcmsST))) {
                    setAliIcmsST("");
                  } else {
                    setAliIcmsST(parseFloat(aliIcmsST).toFixed(2));
                  }
                }}
                placeholder="Alíquota ICMS ST"
              />
            </Grid.Row>
          </Grid.Column>
        )}

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>NCM do material *: </label>
            <br />
            <Input
              error={ncm.length > 0 && ncm.length !== 8}
              value={ncm}
              onChange={(e) => {
                if (validNcm(e.target.value)) {
                  setNcm(e.target.value);
                }
              }}
              placeholder="NCM do material"
            />
          </Grid.Row>
          <br />
          {isSimples ? null : (
            <>
              <Grid.Row textAlign="left">
                <label>Porcentagem da Redução ICMS(%) *: </label>
                <br />
                <br />
                <Input
                  value={reducaoIcms}
                  onChange={(e) => {
                    if (validAliquota(e.target.value.replace(",", "."))) {
                      setReducaoIcms(e.target.value.replace(",", "."));
                    }
                  }}
                  onBlur={() => {
                    if (isNaN(parseFloat(reducaoIcms))) {
                      setReducaoIcms("");
                    } else {
                      setReducaoIcms(parseFloat(reducaoIcms).toFixed(2));
                    }
                  }}
                  placeholder="Redução ICMS"
                />
              </Grid.Row>
              <br />
              <Grid.Row textAlign="left">
                <label>Alíquota IPI (%) *: </label>
                <br />
                <br />
                <Input
                  value={aliIpi}
                  onChange={(e) => {
                    if (validAliquota(e.target.value.replace(",", "."))) {
                      setAliIpi(e.target.value.replace(",", "."));
                    }
                  }}
                  onBlur={() => {
                    if (isNaN(parseFloat(aliIpi))) {
                      setAliIpi("");
                    } else {
                      setAliIpi(parseFloat(aliIpi).toFixed(2));
                    }
                  }}
                  placeholder="Alíquota IPI"
                />
              </Grid.Row>
            </>
          )}
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Preço bruto (valor total incluindo todos os tributos aplicáveis) *:</label>
            <br />
            <Input
              value={price}
              onChange={(e) => {
                if (validateCurrency(e.target.value.replace(",", "."))) {
                  setPrice(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(price))) {
                  setPrice("");
                } else {
                  setPrice(parseFloat(price).toFixed(2));
                }
              }}
              placeholder="Preço Bruto"
            />
          </Grid.Row>
          <br />
          {!isSimples && (
            <Grid.Row textAlign="left">
              <label>Preço líquido (valor negociado sem incidência de tributos) *:</label>
              <br />
              <Input
                disabled={isSimples || (parseFloat(netPrice) === 0)}
                value={netPrice}
                onChange={(e) => {
                  if (validateCurrency(e.target.value.replace(",", "."))) {
                    setNetPrice(e.target.value.replace(",", "."));
                  }
                }}
                onBlur={() => {
                  if (isNaN(parseFloat(netPrice)) || parseFloat(netPrice) <= 0) {
                    setNetPrice("0");
                  } else {
                    setNetPrice(parseFloat(netPrice).toFixed(2));
                  }
                }}
                placeholder="Preço Líquido"
              />
            </Grid.Row>
          )}
          <br />
          {isSimples ? null : (
            <>
              <Grid.Row textAlign="left">
                <label>Com ICMS ST? *</label>
                <br />
                <br />
                <Dropdown
                  placeholder=""
                  search
                  selection
                  value={icmsST}
                  onChange={(_, { value }) => {
                    if (!value) {
                      setAliIcmsST("");
                    }
                    setIcmsST(!!value);
                  }}
                  options={[
                    { key: "Sim", text: "Sim", value: true },
                    { key: "Não", text: "Não", value: false },
                  ]}
                />
              </Grid.Row>

              <br />
            </>
          )}
          <Grid.Row textAlign="left">
            <label>Prazo de entrega (Quantidade em dias) *: </label>
            <br />
            <Input
              type="number"
              min={1}
              step={1}
              value={leadTimeDays}
              onChange={(e) => {
                setLeadTimeDays(e.target.value);
              }}
              placeholder="Lead time (dias)"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <Grid.Row>
            <Button
              onClick={() => {
                history.goBack();
              }}
              color="red"
            >
              Cancelar
            </Button>
            <Button
              loading={loading}
              disabled={!validForm()}
              onClick={saveMaterial}
              primary
            >
              Salvar
            </Button>
            <text className={style.error}>{error}</text>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </div>
  );
}
